export const siteConfig = {
  name: "Automate Analyze Innovate",
  shortName: "AAI",
  tagline: "Modern websites. Connected business systems.",
  url: "https://www.automateanalyzeinnovate.com",
  title: "AAI | Modern Websites, Migrations & Business Systems",
  description:
    "AAI builds and repairs modern websites, protects migrations, and connects forms, operations, automation, and reporting for service businesses.",
  primaryOfferUrl: "/websites-migrations-rescue",
  bookingUrl: "/contact",
  consultationUrl: "https://calendly.com/automateanalyzeinnovate/reactivate-initial-consultation",
  consultationBookingEnabled: true,
  contactEmail: "support@automateanalyzeinnovate.com",
  upworkProfileUrl: "https://www.upwork.com/freelancers/mattt5",
  logo: {
    lockup: "/assets/images/AutomateAnalyzeInnovateLogo.png",
    original: "/assets/images/AutomateAnalyzeInnovate.png",
    favicon: "/assets/images/AutomateAnalyzeInnovateFavicon.ico",
  },
} as const;

export const navLinks = [
  { name: "Websites", href: "/websites-migrations-rescue" },
  { name: "Website Care", href: "/website-care" },
  { name: "Operations", href: "/automation-operations" },
  { name: "Analytics", href: "/analytics-decision-systems" },
  { name: "Lead Flow", href: "/lead-flow-tracking" },
  { name: "Work", href: "/work" },
] as const;

export const sitemapPages = [
  { path: "/", priority: "1.0", changefreq: "weekly", lastmod: "2026-11-04" },
  { path: "/lead-flow-tracking", priority: "0.95", changefreq: "monthly", lastmod: "2026-08-12" },
  { path: "/automation-operations", priority: "0.82", changefreq: "monthly", lastmod: "2026-08-12" },
  { path: "/analytics-decision-systems", priority: "0.82", changefreq: "monthly", lastmod: "2026-08-12" },
  { path: "/websites-migrations-rescue", priority: "0.95", changefreq: "monthly", lastmod: "2026-11-04" },
  { path: "/website-care", priority: "0.9", changefreq: "monthly", lastmod: "2026-11-04" },
  { path: "/work", priority: "0.78", changefreq: "monthly", lastmod: "2026-11-04" },
  { path: "/services", priority: "0.86", changefreq: "monthly", lastmod: "2026-11-04" },
  { path: "/industries", priority: "0.74", changefreq: "monthly", lastmod: "2026-08-12" },
  { path: "/privacy", priority: "0.2", changefreq: "yearly", lastmod: "2026-08-12" },
  { path: "/terms", priority: "0.2", changefreq: "yearly", lastmod: "2026-08-12" },
] as const;
